import { IAuthState } from "src/modules/Auth/store/types";

export const getAgencyByRole = (auth:IAuthState) => {
    return auth.agencyCode;
}


// WEBPACK FOOTER //
// ./src/share/utils/auth.ts